import { render, staticRenderFns } from "./LayoutAlign.vue?vue&type=template&id=11a34eb7&"
import script from "./LayoutAlign.vue?vue&type=script&lang=js&"
export * from "./LayoutAlign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports